import React from 'react';

import { ContentSwitcherValue } from '../../../types';

interface Props {
  values: ContentSwitcherValue[];
}

export const ContentSwitcher: React.FC<Props> = () => {
  return null;
};
